module.exports = __webpack_public_path__ + "img/banner.a1f8c21c.png";